<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
      created(){
      },

      mounted(){
          if(window.location.href.includes('/index')){
              if(localStorage.getItem("user")){
                  this.$store.commit('setTabFlag',false);
              }else {
                  this.$store.commit('setTabFlag',true);
              }
          }else {
              this.$store.commit('setTabFlag',true);
          }

          this.$router.beforeEach((to, from, next) => {
              if(to.path.includes('/index')){
                  if(localStorage.getItem("user")){
                      this.$store.commit('setTabFlag',false);
                  }else {
                      this.$store.commit('setTabFlag',true);
                  }
              }else {
                  this.$store.commit('setTabFlag',true);
              }
              next()
          });
      },
  }
</script>

<style lang="scss" scoped>
  *{
    margin: 0;
    padding: 0;
    text-align: left;
    font-family:"Microsoft YaHei",微软雅黑,"Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB",Arial,sans-serif;
  }
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #F2F4F8;
  }
li {
    list-style: none;
  }
 a{
   text-decoration: none;
 }
</style>
